import { defineStore } from 'pinia'
import * as authApi from '../services/api/auth'

interface IUser {
  id: number | null
  fullName?: string
  email: string
  roles: string[]
  phone?: string
  avatar?: any
}
export const useAuthStore = defineStore('auth', {
  state: () => {
    return {
      roles: [] as string[],
      profile: {} as IUser,
      token: localStorage.getItem('token') || '',
    }
  },

  actions: {
    async login(username: string, password: string) {
      username = username.trim()
      const { data } = await authApi.login(username, password)
      const { token, user } = data
      this.profile = user
      this.token = token
      localStorage.setItem('token', token)
    },
    async checkToken() {
      if (this.token === '') {
        throw Error('Phiên không hợp lệ')
      }
      const { data } = await authApi.checkToken()
      const { user } = data
      this.profile = user
      this.roles = [user.role]
    },
    resetToken() {
      // removeToken();
      this.token = ''
    },
  },
})
